export default angular
  .module("ScriptEvidenceCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptEvidenceController", [
    "$scope",
    "$modal",
    "$rootScope",
    "Scripts",
    "modal",
    function (
      $scope,
      $modal,
      $rootScope,
      Scripts,
      modal,
    ) {
      // open modal to edit journal article
      $scope.openJournalModal = function (journal) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editJournal.html",
          backdrop: "static",
          controller: "ModifyJournalController",
          resolve: {
            journalData() {
              return journal;
            },
          },
        });
        modalInstance.result.then((data) => {
          journal.PUBMED_ID = data.PUBMED_ID;
          journal.TITLE = data.TITLE;
          journal.AUTHORS = data.AUTHORS;
          journal.REF = data.REF;
          journal.ALIAS = data.ALIAS;
        });
      };

      // User clicked add graded evidence button.
      $scope.addGraded = function () {
        $scope.scriptevidence.push({
          SCRIPT_ID: $scope.scriptmeta.ID,
          REF_ID: "",
          TEXT: "",
        });
      };

      $scope.addCochrane = function () {
        $scope.scriptcochrane.push({
          SCRIPT_ID: $scope.scriptmeta.ID,
          COCHRANE_ID: "",
          COCHRANE_GROUP: "",
          TITLE: "",
        });
      };

      $scope.addEBM = function () {
        $scope.scriptebm.push({
          SCRIPT_ID: $scope.scriptmeta.ID,
          LINK_ID: "",
        });
      };

      // open modal to add journal article
      $scope.addJournal = function () {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editJournal.html",
          backdrop: "static",
          controller: "ModifyJournalController",
          resolve: {
            journalData() {
              return ({
                SCRIPT_ID: $scope.scriptmeta.ID,
              });
            },
          },
        });
        modalInstance.result.then((data) => {
          $scope.scriptjournal.push(data);
        });
      };

      // open modal to add internet site
      $scope.addwwwlink = function () {
        $scope.scriptwwwlink.push({
          SCRIPT_ID: $scope.scriptmeta.ID,
          TITLE: "",
          URL: "",
        });
      };

      // User clicked add Other Evidence button.
      $scope.addOtherEvidence = function () {
        $scope.scriptotherevidence.push({
          SCRIPT_ID: $scope.scriptmeta.ID,
          TEXT: "",
        });
      };

      const removeFromArray = (array, elem) => {
        const index = array.indexOf(elem);
        if (index > -1) {
          return array.slice(0, index).concat(array.slice(index + 1));
        }
        return array;
      };

      // open modal to delete graded evidence
      $scope.openDeleteGradedModal = function (evidence) {
        if (!evidence.ID) {
          $scope.scriptevidence = removeFromArray($scope.scriptevidence, evidence);
          return;
        }

        modal.openDelete(evidence.REF_ID, "Graded Evidence").result.then(() => {
          Scripts.deleteScriptEvidence(evidence, (_, status) => {
            if (status === 200) {
              $scope.scriptevidence = removeFromArray($scope.scriptevidence, evidence);
            }
          });
        });
      };

      // open modal to delete cochrane review
      $scope.openDeleteCochraneModal = function (cochrane) {
        if (!cochrane.ID) {
          $scope.scriptcochrane = removeFromArray($scope.scriptcochrane, cochrane);
          return;
        }
        modal.openDelete(cochrane.COCHRANE_ID, "Cochrane Review").result.then(() => {
          Scripts.deleteScriptCochrane(cochrane, (_, status) => {
            if (status === 200) {
              $scope.scriptcochrane = removeFromArray($scope.scriptcochrane, cochrane);
            }
          });
        });
      };

      // open modal to delete EBM guideline
      $scope.openDeleteEBMModal = function (ebm) {
        if (!ebm.ID) {
          $scope.scriptebm = removeFromArray($scope.scriptebm, ebm);
          return;
        }

        modal.openDelete(ebm.LINK_ID, "EBM Guideline").result.then(() => {
          Scripts.deleteScriptEBM(ebm, (_, status) => {
            if (status === 200) {
              $scope.scriptebm = removeFromArray($scope.scriptebm, ebm);
            }
          });
        });
      };

      // open modal to delete Journal article
      $scope.openDeleteJournalModal = function (journal) {
        if (!journal.ID) {
          $scope.scriptjournal = removeFromArray($scope.scriptjournal, journal);
          return;
        }

        modal.openDelete(journal.TITLE, "Journal Article").result.then(() => {
          Scripts.deleteScriptJournal(journal, (_, status) => {
            if (status === 200) {
              $scope.scriptjournal = removeFromArray($scope.scriptjournal, journal);
            }
          });
        });
      };

      // open modal to delete Internet Site
      $scope.openDeletewwwlinkModal = function (wwwlink) {
        if (!wwwlink.ID) {
          $scope.scriptwwwlink = removeFromArray($scope.scriptwwwlink, wwwlink);
          return;
        }

        modal.openDelete(wwwlink.TITLE, "Internet Site").result.then(() => {
          Scripts.deleteScriptwwwlink(wwwlink, (_, status) => {
            if (status === 200) {
              $scope.scriptwwwlink = removeFromArray($scope.scriptwwwlink, wwwlink);
            }
          });
        });
      };

      // open modal to delete Other Evidence
      $scope.openDeleteOtherEvidenceModal = function (otherEvidence) {
        if (!otherEvidence.ID) {
          $scope.scriptotherevidence = removeFromArray($scope.scriptotherevidence, otherEvidence);
          return;
        }

        modal.openDelete(otherEvidence.TEXT, "Other evidence").result.then(() => {
          Scripts.deleteScriptOtherEvidence(otherEvidence, (_, status) => {
            if (status === 200) {
              $scope.scriptotherevidence =
                removeFromArray($scope.scriptotherevidence, otherEvidence);
            }
          });
        });
      };

      $scope.changedField = function (entity, field, refid) {
        $rootScope.changedFields.set(entity, true);
        if (entity === "evidence" && field === "REF_ID") {
          Scripts.loadScriptEvindenceTextByID(refid.REF_ID, (data) => {
            refid.OTSIKKO = data.OTSIKKO;
            refid.NAYTONASTE = data.NAYTONASTE;
          });
        }
        if (entity === "cochrane" && field === "COCHRANE_ID") {
          Scripts.loadScriptCochraneTextByID(refid.COCHRANE_ID, (data) => {
            refid.TITLE = data.COCHRANETEXT;
          });
        }
        if (entity === "EBM" && field === "LINK_ID") {
          Scripts.loadScriptEBMGuidelinesTextByID(refid.LINK_ID, (data) => {
            refid.TITLE = data.OTSIKKO;
          });
        }
        if (entity === "journal" && field === "PUBMED_ID") {
          Scripts.loadScriptJournalArticlesTextByID(refid.PUBMED_ID, (data) => {
            refid.AUTHORS = data.AUTHORS;
            refid.TITLE = data.TITLE;
            refid.REF = data.REF;
            refid.ALIAS = data.ALIAS;
          });
        }
      };

      const updateEvidence = {
        cochrane: Scripts.updateScriptCochrane,
        EBM: Scripts.updateScriptEBMGuideline,
        evidence: Scripts.updateScriptEvidence,
        evidenceother: Scripts.updateScriptOtherEvidence,
        journal: Scripts.updateScriptJournal,
        wwwlink: Scripts.updateScriptWWWlink,
      };

      const saveEvidences = (type, evidences) => {
        const save = updateEvidence[type];
        if (evidences.length > 0) {
          evidences.forEach(e => save(e, () => { Scripts.markSaved(type); }));
        } else {
          Scripts.markSaved(type);
        }
      };

      // Save changes to script. User clicked save changes -button in left menu
      // after modifying script.
      const scriptListener = $rootScope.$on("saveScriptChanges", () => {
        if ($rootScope.changedFields.get("evidence")) {
          saveEvidences("evidence", $scope.scriptevidence.filter(r => !!r.OTSIKKO));
        }
        if ($rootScope.changedFields.get("cochrane")) {
          saveEvidences("cochrane", $scope.scriptcochrane.filter(r => !!r.TITLE));
        }
        if ($rootScope.changedFields.get("EBM")) {
          saveEvidences("EBM", $scope.scriptebm.filter(r => !!r.TITLE));
        }
        if ($rootScope.changedFields.get("journal")) {
          saveEvidences("journal", $scope.scriptjournal.filter(r => !!r.TITLE));
        }
        if ($rootScope.changedFields.get("wwwlink")) {
          saveEvidences("wwwlink", $scope.scriptwwwlink.filter(r => !!r.URL));
        }
        if ($rootScope.changedFields.get("evidenceother")) {
          saveEvidences("evidenceother", $scope.scriptotherevidence.filter(r => !!r.TEXT));
        }
      });
      $scope.$on("$destroy", scriptListener);
    },
  ]);
